import axios from 'axios'

export const triggerCsvReportSend = async () => {
  try {
    const response = await axios.post('/cyber/api/send-csv-report') // Используем новый путь

    if (response.data.success) {
      alert('CSV отчет отправляется в Telegram...')
    } else {
      console.error('API Route сообщил об ошибке при отправке CSV:', response.data.message)
      alert(`Ошибка при отправке CSV: ${response.data.message}`)
    }
  } catch (error: any) {
    console.error('Ошибка при вызове /api/send-csv-report:', error.response?.data || error.message)
    alert('Не удалось запустить отправку CSV отчета.')
  }
}
